import {observer} from 'mobx-react-lite';
import {get} from 'lodash';
import Table from './Table';
import styles from './TransposableTable.module.scss';

const TransposableTable = ({
  columns,
  dataSource,
  headerKey,
  renderHeader = (x) => x,
  vertical = false,
  ...props
}) => {
  const hasHeader = !!headerKey;
  const headerColKey = 'headerCol';
  const classes = hasHeader ? [styles.header] : [];

  if (vertical) {
    classes.push(styles.verticalTable);
    // do magic
    const vertCols = dataSource.map((data, index) => ({
      title: renderHeader(data[headerKey]),
      dataIndex: `el:${index}`,
      key: `el:${index}`,
    }));

    const headerCol = {
      title: '',
      dataIndex: headerColKey,
      key: headerColKey,
    };

    const vertDS = columns.map(({dataIndex, ...col}, columnsIndex) => dataSource.reduce((obj, el, index) => ({
      ...obj,
      [`el:${index}`]: dataIndex ? get(el, dataIndex) : el,
    }), {
      [headerColKey]: col.title,
      key: `${dataIndex}-${columnsIndex}`,
    }));

    return (
      <Table
        className={classes}
        columns={[headerCol, ...vertCols]}
        dataSource={vertDS}
        {...props}
        rowKey={'key'}
        showHeader={hasHeader}
      />
    );
  }

  classes.push(styles.horizontalTable);
  const cols = columns;
  if (hasHeader) {
    const headerCol = {
      title: '',
      dataIndex: headerKey,
      key: headerColKey,
      render: renderHeader,
    };
    cols.unshift(headerCol);
  }
  return (
    <Table
      className={classes}
      columns={cols}
      dataSource={dataSource}
      {...props}
    />
  );
};

export default observer(TransposableTable);
